/* Native Brands A-Z directory. Shopify Storefront vendor facets own the live
   index and category filters. Supabase is used only for the signed-in owner's
   saved_brands rows. */

(function () {
  var SESSION_KEY = 'gettmi:session:v1';
  var RECENT_KEY = 'gettmi:recent-brands:v1';
  var BRAND_CACHE_KEY = 'gettmi:shopify-brand-index:v1';
  var SHOPIFY_ENDPOINT = 'https://dgcxzc-qc.myshopify.com/api/2026-04/graphql.json';
  var SHOPIFY_TOKEN = '24bfa21f68e7f1375c7eb19eae6f792c';
  var letters = '#ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');
  var categories = ['All', 'Accessories', 'Activewear', 'Blazers', 'Dresses', 'Holiday'];
  var categorySearch = {
    Accessories: { productFilters: [{ category: { id: 'aa-2' } }], query: '' },
    Activewear: { productFilters: [], query: 'activewear' },
    Blazers: { productFilters: [], query: 'blazer' },
    Dresses: { productFilters: [{ category: { id: 'aa-1-4' } }], query: '' },
    Holiday: { productFilters: [], query: 'holiday' }
  };
  var categoryRequestId = 0;
  var savedLoadId = 0;
  var state = {
    brands: [],
    categoryBrands: null,
    saved: [],
    selectedCategory: 'All',
    selectedLetter: '#'
  };

  function root() {
    return document.querySelector('[data-gettmi-brands-directory]');
  }

  function config() {
    var node = document.querySelector('[data-gettmi-supabase]');
    return node ? { url: node.dataset.supabaseUrl, key: node.dataset.supabaseKey } : null;
  }

  function brandFollowGated() {
    return Boolean(
      window.GettmiAppGate &&
      typeof window.GettmiAppGate.isEnabled === 'function' &&
      window.GettmiAppGate.isEnabled('follow_brand')
    );
  }

  function session() {
    try {
      return JSON.parse(window.localStorage.getItem(SESSION_KEY) || 'null');
    } catch (error) {
      return null;
    }
  }

  function authHeaders(currentSession, extra) {
    var cfg = config();
    return Object.assign({
      apikey: cfg.key,
      Authorization: 'Bearer ' + currentSession.access_token
    }, extra || {});
  }

  function normalizeBrandKey(value) {
    return String(value || '')
      .normalize('NFKD')
      .replace(/[̀-ͯ]/g, '')
      .toLowerCase()
      .replace(/[^a-z0-9]/g, '');
  }

  function vendorUrl(name) {
    return '/collections/vendors?q=' + encodeURIComponent(name);
  }

  function readJson(key, fallback) {
    try {
      var value = JSON.parse(window.localStorage.getItem(key) || 'null');
      return value === null ? fallback : value;
    } catch (error) {
      return fallback;
    }
  }

  function readSessionJson(key, fallback) {
    try {
      var value = JSON.parse(window.sessionStorage.getItem(key) || 'null');
      return value === null ? fallback : value;
    } catch (error) {
      return fallback;
    }
  }

  function setStatus(message) {
    var mount = root();
    if (!mount) return;
    var status = mount.querySelector('[data-gettmi-brands-status]');
    status.textContent = message || '';
    status.hidden = !message;
  }

  function element(tag, className, textValue) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (typeof textValue !== 'undefined') node.textContent = textValue;
    return node;
  }

  function fetchVendorFacets(category) {
    var variables = categorySearch[category] || { productFilters: [], query: '' };
    var query = [
      'query BrandDirectoryVendors($productFilters: [ProductFilter!], $query: String!) {',
      'search(query: $query, first: 1, types: [PRODUCT], productFilters: $productFilters) {',
      'productFilters { id values { label count } }',
      '}',
      '}'
    ].join(' ');
    return window.fetch(SHOPIFY_ENDPOINT, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': SHOPIFY_TOKEN
      },
      body: JSON.stringify({ query: query, variables: variables })
    }).then(function (response) {
      if (!response.ok) throw new Error();
      return response.json();
    }).then(function (payload) {
      if (payload.errors && payload.errors.length) throw new Error();
      var filters = payload.data && payload.data.search && payload.data.search.productFilters;
      var vendors = (filters || []).find(function (filter) {
        return filter.id === 'filter.p.vendor';
      });
      return (vendors && vendors.values || []).map(function (value) {
        return {
          name: String(value.label || '').trim(),
          productCount: Number(value.count || 0)
        };
      }).filter(function (brand) {
        return brand.name && brand.productCount > 0;
      }).sort(function (left, right) {
        return left.name.localeCompare(right.name);
      });
    });
  }

  function renderFilters() {
    var mount = root();
    if (!mount) return;
    var alphabet = mount.querySelector('[data-gettmi-brand-alphabet]');
    var categoryMount = mount.querySelector('[data-gettmi-brand-categories]');
    alphabet.replaceChildren();
    categoryMount.replaceChildren();

    letters.forEach(function (letter) {
      var button = element('button', 'gettmi-brands__letter', letter);
      button.type = 'button';
      button.dataset.gettmiBrandLetter = letter;
      button.classList.toggle('is-active', state.selectedLetter === letter);
      alphabet.appendChild(button);
    });
    categories.forEach(function (category) {
      var button = element('button', 'gettmi-brands__category', category);
      button.type = 'button';
      button.dataset.gettmiBrandCategory = category;
      button.classList.toggle('is-active', state.selectedCategory === category);
      categoryMount.appendChild(button);
    });
  }

  function trackRecent(name) {
    var recent = readJson(RECENT_KEY, []).filter(function (item) {
      return normalizeBrandKey(item) !== normalizeBrandKey(name);
    });
    recent.unshift(name);
    window.localStorage.setItem(RECENT_KEY, JSON.stringify(recent.slice(0, 8)));
  }

  function brandPill(name) {
    var link = element('a', 'gettmi-brands__pill', name);
    link.href = vendorUrl(name);
    link.dataset.gettmiBrandOpen = name;
    return link;
  }

  function renderPills() {
    var mount = root();
    if (!mount) return;
    var savedMount = mount.querySelector('[data-gettmi-saved-brands]');
    var recentMount = mount.querySelector('[data-gettmi-recent-brands]');
    var recent = readJson(RECENT_KEY, []);
    savedMount.replaceChildren();
    recentMount.replaceChildren();
    state.saved.forEach(function (name) { savedMount.appendChild(brandPill(name)); });
    recent.forEach(function (name) { recentMount.appendChild(brandPill(name)); });
    mount.querySelector('[data-gettmi-saved-brands-empty]').hidden = Boolean(state.saved.length);
    mount.querySelector('[data-gettmi-recent-brands-empty]').hidden = Boolean(recent.length);
  }

  function renderBrands() {
    var mount = root();
    if (!mount) return;
    var list = mount.querySelector('[data-gettmi-brand-list]');
    var source = state.categoryBrands || state.brands;
    var filtered = source.filter(function (brand) {
      return state.selectedLetter === '#' || brand.name.charAt(0).toUpperCase() === state.selectedLetter;
    });
    var groups = {};
    filtered.forEach(function (brand) {
      var letter = brand.name.charAt(0).toUpperCase();
      if (!groups[letter]) groups[letter] = [];
      groups[letter].push(brand);
    });
    list.replaceChildren();
    Object.keys(groups).sort().forEach(function (letter) {
      var section = element('section', 'gettmi-brands__letter-group');
      section.appendChild(element('h3', '', letter));
      var grid = element('div', 'gettmi-brands__grid');
      groups[letter].forEach(function (brand) {
        var row = element('div', 'gettmi-brands__row');
        var heart = element(
          'button',
          'gettmi-brands__heart',
          state.saved.indexOf(brand.name) === -1 ? '♡' : '♥'
        );
        heart.type = 'button';
        heart.setAttribute('aria-label', (state.saved.indexOf(brand.name) === -1 ? 'Save ' : 'Remove ') + brand.name);
        heart.dataset.gettmiBrandSave = brand.name;
        heart.dataset.gettmiAppGate = 'follow_brand';
        heart.dataset.gettmiAppGatePlacement = 'brands_directory_heart';
        heart.classList.toggle('is-active', state.saved.indexOf(brand.name) !== -1);
        var link = element('a', 'gettmi-brands__name', brand.name);
        link.href = vendorUrl(brand.name);
        link.dataset.gettmiBrandOpen = brand.name;
        row.append(heart, link);
        grid.appendChild(row);
      });
      section.appendChild(grid);
      list.appendChild(section);
    });
    if (!filtered.length) list.appendChild(element('p', 'gettmi-brands__empty', 'No brands found in this filter.'));
  }

  function loadSavedBrands() {
    var cfg = config();
    var currentSession = session();
    savedLoadId += 1;
    var loadId = savedLoadId;
    state.saved = [];
    renderPills();
    renderBrands();
    if (!cfg || !currentSession || !currentSession.user_id) return;
    window.fetch(
      cfg.url + '/rest/v1/saved_brands?select=brand_name&user_id=eq.' +
        encodeURIComponent(currentSession.user_id) + '&order=created_at.desc',
      { headers: authHeaders(currentSession) }
    ).then(function (response) {
      if (!response.ok) throw new Error();
      return response.json();
    }).then(function (rows) {
      var latestSession = session();
      if (loadId !== savedLoadId || !latestSession || latestSession.user_id !== currentSession.user_id) return;
      state.saved = (rows || []).map(function (row) { return row.brand_name; }).filter(Boolean);
      renderPills();
      renderBrands();
    }).catch(function () {
      if (loadId !== savedLoadId) return;
      setStatus('Your saved brands could not load right now.');
    });
  }

  function toggleSavedBrand(name) {
    if (brandFollowGated()) return;
    var cfg = config();
    var currentSession = session();
    if (!cfg || !currentSession || !currentSession.user_id) {
      setStatus('Sign in from Profile to save brands.');
      return;
    }
    var wasSaved = state.saved.indexOf(name) !== -1;
    state.saved = wasSaved
      ? state.saved.filter(function (item) { return item !== name; })
      : state.saved.concat(name);
    renderPills();
    renderBrands();

    var request = wasSaved
      ? window.fetch(
        cfg.url + '/rest/v1/saved_brands?user_id=eq.' + encodeURIComponent(currentSession.user_id) +
          '&brand_name=eq.' + encodeURIComponent(name),
        {
          method: 'DELETE',
          headers: authHeaders(currentSession, { Prefer: 'return=minimal' })
        }
      )
      : window.fetch(cfg.url + '/rest/v1/saved_brands?on_conflict=user_id,brand_name', {
        method: 'POST',
        headers: authHeaders(currentSession, {
          'Content-Type': 'application/json',
          Prefer: 'resolution=merge-duplicates,return=minimal'
        }),
        body: JSON.stringify({
          brand_name: name,
          source: 'brands',
          user_id: currentSession.user_id
        })
      });

    request.then(function (response) {
      if (!response.ok) throw new Error();
      var latestSession = session();
      if (!latestSession || latestSession.user_id !== currentSession.user_id) return;
      setStatus('');
    }).catch(function () {
      var latestSession = session();
      if (!latestSession || latestSession.user_id !== currentSession.user_id) return;
      state.saved = wasSaved
        ? state.saved.concat(name)
        : state.saved.filter(function (item) { return item !== name; });
      renderPills();
      renderBrands();
      setStatus(wasSaved
        ? 'We could not remove that brand. Try again.'
        : 'We could not save that brand. Try again.');
    });
  }

  function selectCategory(category) {
    categoryRequestId += 1;
    var requestId = categoryRequestId;
    state.selectedCategory = category;
    state.categoryBrands = category === 'All' ? null : [];
    renderFilters();
    renderBrands();
    if (category === 'All') {
      setStatus('');
      return;
    }
    setStatus('Loading ' + category.toLowerCase() + ' brands…');
    fetchVendorFacets(category).then(function (brands) {
      if (requestId !== categoryRequestId) return;
      state.categoryBrands = brands;
      renderBrands();
      setStatus('');
    }).catch(function () {
      if (requestId !== categoryRequestId) return;
      state.categoryBrands = [];
      renderBrands();
      setStatus('This category could not load right now.');
    });
  }

  function loadBrands() {
    var cached = readSessionJson(BRAND_CACHE_KEY, []);
    if (cached.length) {
      state.brands = cached;
      renderBrands();
      setStatus('');
    }
    fetchVendorFacets('All').then(function (brands) {
      state.brands = brands;
      window.sessionStorage.setItem(BRAND_CACHE_KEY, JSON.stringify(brands));
      renderBrands();
      setStatus('');
    }).catch(function () {
      if (!state.brands.length) setStatus('Brands could not load right now.');
    });
  }

  function run() {
    if (!root()) return;
    renderFilters();
    renderPills();
    loadBrands();
    loadSavedBrands();
  }

  document.addEventListener('click', function (event) {
    var back = event.target.closest('[data-gettmi-brands-back]');
    if (back) {
      var mount = root();
      if (window.history.length > 1) window.history.back();
      else window.location.assign(mount.dataset.homeUrl || '/');
      return;
    }
    var letter = event.target.closest('[data-gettmi-brand-letter]');
    if (letter) {
      state.selectedLetter = letter.dataset.gettmiBrandLetter;
      renderFilters();
      renderBrands();
      return;
    }
    var category = event.target.closest('[data-gettmi-brand-category]');
    if (category) {
      selectCategory(category.dataset.gettmiBrandCategory);
      return;
    }
    var save = event.target.closest('[data-gettmi-brand-save]');
    if (save) {
      toggleSavedBrand(save.dataset.gettmiBrandSave);
      return;
    }
    var open = event.target.closest('[data-gettmi-brand-open]');
    if (open) trackRecent(open.dataset.gettmiBrandOpen);
  });

  document.addEventListener('gettmi:signed-in', loadSavedBrands);
  document.addEventListener('gettmi:signed-out', loadSavedBrands);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();
